export default function getResource(label, vars = []) {
    const resources = {
        instructions: `Select up to <b>${vars[0]} free samples</b> per order. ${vars[1]}. Subject to availability.`,
        tierText: `<b>${vars[0]} samples with a $${vars[1]} minimum</b> purchase`,
        startTierText: 'Get',
        appendTierText: 'or'
    };

    return resources[label];
}
